import { type ButtonKindEnum } from '@jusbrasil-web/shared-apollo-client/types'

type OfferLockButtonSlot = {
  readonly label?: string | null
  readonly kind?: ButtonKindEnum | null
}

type ResolvedButton = { label: string; kind: ButtonKindEnum }

export function resolveOfferLockButton(
  buttons: readonly OfferLockButtonSlot[] | null | undefined,
  index: number,
  fallback: ResolvedButton
): ResolvedButton {
  const btn = buttons?.[index]

  return {
    label: btn?.label ?? fallback.label,
    kind: btn?.kind ?? fallback.kind,
  }
}
